// ═══════════════════════════════════════════════════════════════════════════
// core/lib/rentabilidadMinima — resolver PURO del CORTE de rentabilidad
// (ADR 032). ESPEJO ESM de functions/lib/rentabilidadMinima.js — si cambia
// allá, cambiar acá (mismo contrato, mismos tests golden).
// ═══════════════════════════════════════════════════════════════════════════
//
// La "rentabilidad mínima (corte)" es el margen mínimo aceptado (piso). Se
// guarda como campo `rentabilidadMinima` (fracción en (0,1); 0.30 = 30%) en
// cada entidad del árbol de producto y se resuelve por cascada — el primero
// con valor gana: Producto → Categoría → Marca → Proveedor → Empresa.
// ═══════════════════════════════════════════════════════════════════════════

// Una rentabilidad mínima válida es una fracción estricta en (0,1). 0, 1, null,
// negativos o no-numéricos = "sin override" → la cascada sigue al siguiente nivel.
export function esFraccionValida(v) {
  const n = Number(v)
  return Number.isFinite(n) && n > 0 && n < 1
}

/**
 * Resuelve el corte de rentabilidad por cascada producto → categoría → marca →
 * proveedor → empresa. Cada arg es el `rentabilidadMinima` (fracción) de esa
 * entidad, o null/undefined si no tiene override.
 *
 * @returns {number|null} el primer corte válido en orden, o null si ninguno.
 */
export function resolverRentabilidadMinima({ producto, categoria, marca, proveedor, empresa } = {}) {
  for (const v of [producto, categoria, marca, proveedor, empresa]) {
    if (esFraccionValida(v)) return Number(v)
  }
  return null
}
